<template>
  <div class="indexPage container">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <!-- id="index_img" -->
    <div id class="pt-3">
      <div class="position-relative overflow-hidden d-flex align-items-center">
        <div class="mt-1 d-none d-lg-flex justify-content-end">
          <img src="../assets/UI_BannerLoginIn.png" />
        </div>
        <div class="d-block d-lg-none w-100 position-relative login_eaxm_box">
        </div>
        <div id="login_exam_com"
          class="d-flex mt-3 mx-auto mr-lg-5 pb-2 pb-lg-2 px-lg-3 w-100 h-100">
          <div class="login_box w-100 mt-3 mt-lg-4 mx-auto mx-lg-0 pt-2 pb-4 p-lg-0">
              <div class="w-100 d-flex pt-2 mb-3 letter-s-2 align-items-stretch">
                <div href="#"
                  class="px-1 pb-2 w-50 m-0 border-bottom border-deepgold border-b-3 text-center">
                  <b class="text-deepgold h6 mb-0">會員登入</b>
                </div>
                <div class="border-bottom border-light w-50">
                </div>
              </div>
              <comlogin class="mx-lg-n2 mt-4 px-3 px-lg-0"></comlogin>
          </div>
        </div>
        <div class="position-absolute" style="top:0;left:0">
          <div class="row p-0">
            <div class="col-12">
              <a href="https://www.magee.tw" class="text-deepgold"
                style="text-shadow:0px 1px 0 #fff">
                <img src="https://www.magee.tw/img/LOGO.ae1aaf32.png" alt="馬跡中心 - 首頁" width="100%" class="d-inline-block align-top" style="max-width: 165px; width: auto;">
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters px-4 mt-5">
      <div class="col-12 d-md-none order-3 mt-4">
        <b-card no-body class="mb-1 w-100 border-0" id="about">
          <b-card-header header-tag="header" class="px-3 py-2 bg-gold text-white" role="tab">
            <h2 class="h6 m-0 d-flex align-items-center" role="button" v-b-toggle.about-text>
              認識馬跡測驗平台
              <font-awesome-icon :icon="['fas', 'chevron-down']" class="small ml-auto text-white" />
            </h2>
          </b-card-header>
          <b-collapse id="about-text" accordion="about">
            <b-card-body>
              <b-card-text>
                聞道有先後，術業有專攻，馬跡中心一直以來秉持認真、
                用心的態度，希望將我們的帶團、考照經驗，無私的與學員互相交流、
                傳承，期許每位學員未來在踏上領隊導遊的工作上，能更順利、成功！
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <div class="col-12 order-1">
        <div class="row">
          <div id="index_mid" class="col-md-4"></div>
          <div id="index_mid_title"
            class="col-md-8 d-flex justify-content-md-center align-items-center">
            <h6 class="text-center my-2 text-white">試卷選單
            </h6>
            <font-awesome-icon :icon="['fas', 'chevron-down']"
              class="small ml-auto text-secondary d-md-none" />
          </div>
        </div>
      </div>
      <div class="col-12 order-2">
        <div class="row">
          <div id="about" class="col-md-4 p-4 d-none d-md-block">
            <h4>認識馬跡測驗平台</h4>
            <small>
              聞道有先後，術業有專攻，馬跡中心一直以來秉持認真、
              用心的態度，希望將我們的帶團、考照經驗，無私的與學員互相交流、
              傳承，期許每位學員未來在踏上領隊導遊的工作上，能更順利、成功！
            </small>
          </div>
          <div id="questionFilter" class="col-md-8 py-4 px-3 p-md-4 d-flex flex-column"
            style="min-height:280px">
            <div class="row no-gutters d-flex px-1 align-items-start align-items-md-center">
              <div class='col-12 row no-gutters p-0 mb-3'>
                <label for="" class='mb-2 m-lg-0 col-12 col-md-2' style="color:#8f5e3a;">考試簡稱</label>
                <div class='col'>專門職業及技術人員普通考試導遊人員、領隊人員考試</div>
              </div>
              <!-- ===============修正===========--->
              <div class='col-12 row no-gutters mb-3 align-items-center'>
                <label for="" class='mb-2 m-lg-0 col-12 col-md-2' style="color:#8f5e3a;">試題查詢</label>
                <div class='col'>
                  <div class='d-flex m-0 justify-content-between'>
                    <b-input-group class="flex-column flex-md-row">
                      <b-form-select class="rounded-0 border-0 shadow-sm mb-1 mb-md-0 m-0" v-model="selecteddata.year">
                        <b-form-select-option value="" disabled>選擇年度 </b-form-select-option>
                        <b-form-select-option v-for='item in getyear' :value="item.value">
                          {{item.name}}
                        </b-form-select-option>
                      </b-form-select>
                      <b-form-select class="border-0 shadow-sm mb-1 mb-md-0 m-0" v-model="selecteddata.method">
                        <b-form-select-option value="" disabled>考試類科 </b-form-select-option>
                        <b-form-select-option v-for='item in getMethod' :value="item.value">
                          {{item.name}}
                        </b-form-select-option>
                      </b-form-select>
                      <b-form-select class="border-0 shadow-sm mb-1 mb-md-0 m-0" v-model="selecteddata.lanuage">
                        <b-form-select-option value="" disabled>考試語種 </b-form-select-option>
                        <b-form-select-option v-for='item in getLanuage' :value="item.value">
                          {{item.name}}
                        </b-form-select-option>
                      </b-form-select>
                      <b-input-group-append class="ml-auto">
                        <button class='btn btn-primary rounded-0' @click='searchexamlist'> 查詢</button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </div>
              </div>
              <div class='col-12 pt-2' v-if='getExamCount>0'>
                <h6 class='text-muted small'>共 {{searchlist.length}} 考試 {{getExamCount}} 科目
                </h6>
                <div class='w-100' v-for='item in searchlist'>
                  <div v-for='(iit,iitk) in item.data' :key="iitk"
                    class='row no-gutters mb-1 py-2 shadow-sm' style="background:rgba(255,255,255,0.4)">
                    <div class='col-12 col-md-7 text-nowrap px-3 py-2'>
                      {{item.year}} 年度{{iit.prename}}{{selectedMethodTmp}} - {{iit.name}}
                    </div>
                    <div class='col d-flex align-items-center'>
                      <div class='flex-fill d-flex justify-content-end'>
                        <button class='btn btn-link' v-if="!isLogin"
                          @click='goexam("test",iit,item.year)'>試用版</button>
                        <button class='btn btn-link'
                          @click='goexam("member",iit,item.year)'>會員版</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <publicfooter />
    <!-- modal -->
    <b-modal v-if="!isLogin" hide-footer size="sm" id="modal-login" body-class="px-0 pt-0"
      header-class="p-0 m-0" centered>
      <template #modal-header="{ close }">
        <div class="position-relative w-100">
          <div class="w-100 d-flex pt-2 letter-s-2 align-items-stretch">
            <div href="#"
              class="px-1 pb-2 pt-3 w-50 m-0 border-bottom border-deepgold border-b-3 text-center">
              <b class="text-deepgold h5 mb-0">會員登入</b>
            </div>
            <div class="border-bottom border-light w-50">
            </div>
          </div>
          <button type="button" aria-label="關" class="position-absolute close py-2 px-3"
            style="right:1rem;top: 1rem;line-height:17px;" @click="close()">
            <font style="vertical-align: inherit;">×</font>
          </button>
        </div>
      </template>
      <div class="bg-light pt-4 pb-2 mb-2">
        <comlogin></comlogin>
      </div>
    </b-modal>
    <!-- selectedExamMethod -->
    <b-modal v-else header-class="p-0 border-0 mb-2" footer-class="border-0" id="modal-check_eaxm"
      centered >
      <template #modal-header="{ close }">
        <div class="d-flex flex-fill justify-content-center align-items-center position-relative">
          <div class="mx-auto">
            <h5
              class="mt-3 mb-0 text-center border-bottom border-deepgold border-b-3 text-deepgold py-2">
              進入測驗</h5>
          </div>
          <div class="position-absolute" style="right:1rem">
            <button type="button" class="close" aria-label="Close" @click="close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>
      <div class="col-12 col-md-10 mx-auto my-2">
        <div class="row no-gutters">
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-start">
            <span class="w-100 text-left text-md-center text-deepgold">試卷名稱</span>
          </div>
          <div class="col-8 col-md-9 d-flex align-items-center">
            <h6 class="mb-0 font-weight-bold">
              {{`${examdata.year}年度${examdata.prename}${selectedMethodTmp}-${examdata.name}`}}
            </h6>
          </div>
          <div class="col-12 px-2">
            <hr class="w-100" />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-start"
            v-if='isLogin === true'>
            <span class="w-100 text-left text-md-center text-deepgold">點數</span>
          </div>
          <div class="col-8 col-md-9 d-flex align-items-center" v-if='isLogin === true'>
            <span style="color:#da8c55" v-if=" isSelected === true">
              {{userInfo.radcount}} 點，扣除 10 點，剩餘 {{userInfo.radcount-10}} 點</span>
            <span v-else>
              已購買過考題，目前剩餘{{userInfo.radcount}} 點
            </span>
          </div>
          <div class="col-12 px-2">
            <hr class="w-100" />
          </div>
          <div class="col-4 col-md-3 d-flex justify-content-center align-items-center">
            <span class="w-100 text-left text-md-center text-deepgold">試卷內容</span>
          </div>
          <div class="col-8 col-md-9">
            <span>單一選擇題</span>
          </div>
          <div class="col-12 px-2">
            <hr class="w-100" />
          </div>
          <div class="col-12">
            <div class="row no-gutters">
              <div class="col-4 col-md-3 d-flex mt-2">
                <span class="w-100 text-left text-md-center text-deepgold">測驗時間</span>
              </div>
              <div class="col-8 col-md-9 mt-2">
                <div>
                  {{examdata.method=="C"?60:80}}分鐘
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 px-2">
            <hr class="w-100" />
          </div>
          <div class="col-4 col-md-3 d-flex mt-2">
            <span class="w-100 text-left text-md-center text-deepgold">作答模式</span>
          </div>
          <div class="col-8 col-md-9 d-flex flex-wrap mt-2 ">
            <div class="mr-4">
              <b-form-radio v-model="allwaysAns" :value="false" name="switchExamMode">計時交卷
              </b-form-radio>
            </div>
            <div>
              <b-form-radio v-model="allwaysAns" :value="true" name="switchExamMode">隨答隨改
              </b-form-radio>
              <span class=""></span>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{close}">

        <button class='btn btn-warning' @click='getQuestionsVip(close)'>開始測驗</button>
        <button class='btn btn-light' @click='close'>取消</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import ctrl from './js/index';

  export default ctrl;

</script>
